import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Alert,
  AlertTitle,
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

const alertIconBySeverity = {
  success: <CheckIcon fontSize="inherit" />,
  error: <PriorityHighIcon fontSize="inherit" />,
};

const UIAlert = ({
  title,
  subTitle,
  children,
  severity,
  onClose,
  closeAriaLabel,
  closable,
  icon,
  action,
  ...props
}) => {
  const [dismissed, setDismissed] = useState(false);
  const description = subTitle || children;
  const alertSeverity = severity === "failed" ? "error" : severity;
  const resolvedIcon =
    icon === undefined ? alertIconBySeverity[alertSeverity] : icon;
  const handleClose = (event) => {
    setDismissed(true);
    if (onClose) {
      onClose(event);
    }
  };
  const resolvedAction =
    action ||
    (closable ? (
      <IconButton
        aria-label={closeAriaLabel}
        color="inherit"
        size="small"
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>
    ) : null);

  if (dismissed) {
    return null;
  }

  return (
    <Alert
      severity={alertSeverity}
      icon={
        resolvedIcon ? (
          <Box className="ui-alert__icon">{resolvedIcon}</Box>
        ) : (
          false
        )
      }
      action={resolvedAction}
      {...props}
    >
      {title ? <AlertTitle>{title}</AlertTitle> : null}
      {description ? (
        <Typography component="div" className="ui-alert__subtitle">
          {description}
        </Typography>
      ) : null}
    </Alert>
  );
};

UIAlert.propTypes = {
  title: PropTypes.node,
  subTitle: PropTypes.node,
  children: PropTypes.node,
  severity: PropTypes.oneOf(["success", "error", "failed"]),
  onClose: PropTypes.func,
  closeAriaLabel: PropTypes.string,
  closable: PropTypes.bool,
  icon: PropTypes.node,
  action: PropTypes.node,
};

UIAlert.defaultProps = {
  title: null,
  subTitle: null,
  children: null,
  severity: "success",
  onClose: undefined,
  closeAriaLabel: "Close alert",
  closable: true,
  icon: undefined,
  action: null,
};

export default UIAlert;
